<template>
  <v-card flat rounded="lg">
    <v-card-title class="subtitle-1 font-weight-bold">Produtos</v-card-title>
    <v-card-text>
      <dialog-produtos-disp-insumos />
      <btn-adicionar-produto-insumos class="mb-3" />
      <v-alert
        v-if="lista_itens.length == 0"
        type="info"
        text
        class="mt-3 subtitle-1"
      >
        Nenhum produto adicionado
      </v-alert>
      <template v-else>
        <v-divider></v-divider>
        <template v-for="(item, i) in lista_itens">
          <v-list-item :key="i" :class="{ 'grey lighten-4': !isMobile() }">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ item.descricao }}</v-list-item-title>
              <v-list-item-subtitle :class="{'subtitle-2': isMobile(), 'subtitle-1': !isMobile()}">
                <p class="mb-3">
                  {{ item.embalagemSelecionada.descricao }} ({{ item.grupo }}-{{
                    item.subgrupo
                  }}-{{ item.item }})
                </p>
                <p class="mb-1">
                  Quantidade:
                  <span class="float-right font-weight-bold">{{
                    item.quantidade
                  }}</span>
                </p>
                <p class="mb-1">
                  Valor:
                  <span class="float-right font-weight-bold">{{
                    formatarMoeda(item.unitario * item.quantidade)
                  }}</span>
                </p>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon :small="isMobile()"
                ><v-icon color="error" @click="removerItem(i)"
                  >mdi-trash-can-outline</v-icon
                ></v-btn
              >
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="item.id"></v-divider>
        </template>
        <v-row dense class="mt-2">
          <v-col cols="12">
            <span class="black--text subtitle-1"
              >Total dos produtos

              <v-chip
                class="float-right font-weight-bold"
                :small="isMobile()"
                >{{ formatarMoeda(vlrTotalProdutos()) }}</v-chip
              >
            </span>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import BtnAdicionarProdutoInsumos from "../botoes/BtnAdicionarProdutoInsumos.vue";
import DialogProdutosDispInsumos from "../dialogs/DialogProdutosDispInsumos.vue";
import { formatMoeda } from "@/global";
export default {
  components: { BtnAdicionarProdutoInsumos, DialogProdutosDispInsumos },
  computed: {
    ...mapState("insumos", ["lista_itens"]),
  },
  methods: {
    ...mapMutations("insumos", ["setListaItens"]),
    ...mapGetters("insumos", ["vlrTotalProdutos"]),
    ...mapActions("insumos", ["atualizarListaItens"]),
    isMobile() {
      return this.$mq == "sm";
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    removerItem(pos) {
      this.lista_itens.splice(pos, 1);
      this.atualizarListaItens();
    },
  },
  created() {
    this.setListaItens();
  },
};
</script>

<style>
</style>